import { Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MeetingOptions } from "./MeetingOptions";
import { JoinMeeting } from "./JoinMeeting";
import { SheduleMeeting } from "./SheduleMeeting";
import "react-calendar/dist/Calendar.css";
import { useLocation } from "react-router-dom";
import OneOnOneMeeting from "./OneOnOneMeeting";
import GroupMeeting from "./GroupMeeting";
import PrepareMeeting from "./PrepareMeeting";
import JoinMeetingIframe from "./JoinMeetingIframe";
import CreateMeetingIframe from "./CreateMeetingIframe";

export const MeetingsDirectory = () => {

  const [displayScreen, setDisplayScreen] = useState("");

  const { state } = useLocation();

  return (
    <Box>
      {displayScreen === "" && (
        <MeetingOptions setDisplayScreen={setDisplayScreen} />
      )}
      {displayScreen === "create-meeting" && (
        <CreateMeetingIframe/>
      )}
      {displayScreen === "join-meeting" && (
        <JoinMeetingIframe/>
      )}

      {displayScreen === "prepare-meeting" && (
        <PrepareMeeting setDisplayScreen={setDisplayScreen} />
      )}
      {displayScreen === "schedule-meeting" && (
        <SheduleMeeting setDisplayScreen={setDisplayScreen} />
      )}
      {displayScreen === "group-meeting" && <GroupMeeting />}
      {displayScreen === "one_on_one-meeting" && <OneOnOneMeeting />}
    </Box>
  );
};
